<template>
    <div role="tabcard" class="tab-pane" id="customer">
        <add-customer :project="project"></add-customer>
        <customer-list v-if="project && project.customers.length > 0" :project="project" :user="user"></customer-list>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'team', 'project'],

        created: function() {

        },

        mounted: function() {

        },

        data: function() {
            return {
            };
        },

        computed: {
            
        },

        methods: {
           
        }
    }
</script>
